import { Breadcrumbs, Typography, Tabs, Tab } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { useNavigate, useParams } from 'react-router-dom'

import Content from 'components/common/Content'
import { StyledRouterLink } from 'components/common/StyledRouterLink'
import { TabPanel } from 'components/common/TabPanel'
import Icon from 'components/Icon'
import { Header } from 'components/navigation/Header'
import { useGetStatusChecksUrls } from 'components/status-checks/hooks/use-get-status-checks-urls'
import { AuthenticationList } from 'components/status-checks/list/AuthenticationList'
import { StatusCheckList } from 'components/status-checks/list/StatusCheckList'
import { StatusChecksHeader } from 'components/status-checks/list/StatusChecksHeader'
import { useTranslation } from 'hooks/use-translation'
import { muiTheme } from 'mui-theme'
import theme from 'theme'

export const StatusChecksPage: React.FC = () => {
  const { trans } = useTranslation()
  const { tab } = useParams<{
    tab: string
  }>()
  const navigate = useNavigate()
  const [currentTab, setCurrentTab] = useState(tab === 'authentication' ? 1 : 0)
  const statusChecksUrls = useGetStatusChecksUrls()

  useEffect(() => {
    setCurrentTab(tab === 'authentication' ? 1 : 0)
  }, [tab])

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    navigate(
      newValue === 1
        ? statusChecksUrls.authentication()
        : statusChecksUrls.list(),
      {
        state: {
          clearSearchState: true
        }
      }
    )
  }

  return (
    <>
      <Helmet title={trans('status_checks.page_name')} />
      <Header>
        <Breadcrumbs aria-label="breadcrumb">
          <Typography color="text.primary">
            <Icon css={{ marginRight: muiTheme.spacing(1) }} icon="wavePulse" />
            {trans('status_checks.label.plural')}
          </Typography>
        </Breadcrumbs>
      </Header>
      <Content
        css={{
          display: 'grid',
          gridTemplateColumns: 'minmax(0, 1fr)',
          gridAutoRows: 'min-content'
        }}
      >
        <StatusChecksHeader
          buttonProps={{
            // @ts-ignore TODO: figure out why the import is referencing our common component ButtonProps type instead of MUI's
            component: StyledRouterLink,
            to: statusChecksUrls.new()
          }}
          buttonText={trans('status_checks.label.singular')}
          description={trans('status_checks.header.description')}
          title={trans('status_checks.label.plural')}
        />
        <Tabs value={currentTab} onChange={handleTabChange}>
          <Tab
            css={{ textTransform: 'uppercase' }}
            data-testid="status-checks-list-tab"
            label={trans('status_checks.label.plural')}
          />
          <Tab
            css={{ textTransform: 'uppercase' }}
            data-testid="status-checks-authentication-list-tab"
            label={trans('status_checks.authentication')}
          />
        </Tabs>
        <TabPanel
          currentTabIndex={currentTab}
          tabIndex={0}
          tabPanelCss={{ padding: `${theme.space[5]}px 0px` }}
        >
          <StatusCheckList />
        </TabPanel>
        <TabPanel
          currentTabIndex={currentTab}
          tabIndex={1}
          tabPanelCss={{ padding: `${theme.space[3]}px 0px` }}
        >
          <AuthenticationList />
        </TabPanel>
      </Content>
    </>
  )
}
